import { Component, EventEmitter, Output } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';

@Component({
  selector: 'app-gurukula-seva-contemplation',
  templateUrl: './gurukula-seva-contemplation.component.html',
  styleUrls: ['./gurukula-seva-contemplation.component.scss']
})
export class GurukulaSevaContemplationComponent {

  @Output() formGroupChange = new EventEmitter<FormGroup>();
  @Output() nextStep = new EventEmitter<void>();
  @Output() previous = new EventEmitter<void>();

  gurukulaSevaForm!: FormGroup;
  submitted = false;

  constructor(private fb: FormBuilder) {}

  ngOnInit(): void {
    this.gurukulaSevaForm = this.fb.group({
      gurukulaStudent: ['', [Validators.required, Validators.minLength(10), Validators.maxLength(5000)]],
      sevaQualities: ['', [Validators.required, Validators.minLength(10), Validators.maxLength(5000)]],
      sevaPlans: ['', [Validators.required, Validators.minLength(10), Validators.maxLength(5000)]],
      ashramContribution: ['', [Validators.required, Validators.minLength(10), Validators.maxLength(5000)]],
    });

    this.formGroupChange.emit(this.gurukulaSevaForm);
  }

  onSubmit() {
    this.submitted = true;
    if (this.gurukulaSevaForm.valid) {
      this.nextStep.emit();
    }
  }

  goToBack() {
    this.previous.emit();
  }
}
